import React from "react";
import { Box, CircularProgress, Alert } from "@mui/material";
import FolderIcon from "@diligentcorp/atlas-react-icons/dist/esm/lens/Folder.js";
import GridViewCard from "./GridViewCard";
import EmptyState from "./EmptyState";

interface DocumentTypesListProps {
  documentTypes: Array<{ key: string; value: string }>;
  documentTypesLoading: boolean;
  documentTypesError: string | null;
  onFolderClick: (documentType: { key: string; value: string }) => void;
}

const DocumentTypesList: React.FC<DocumentTypesListProps> = ({
  documentTypes,
  documentTypesLoading,
  documentTypesError,
  onFolderClick,
}) => {
  if (documentTypesLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="200px"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (documentTypesError) {
    return (
      <Alert severity="error" sx={{ mb: 2 }}>
        {documentTypesError}
      </Alert>
    );
  }

  // Show empty state if no document types available
  if (documentTypes.length === 0) {
    return (
      <EmptyState
        title="No items to display."
        subtitle="No document types available"
      />
    );
  }

  return (
    <Box
      data-testid="document-types-grid"
      sx={{
        display: "grid",
        gridTemplateColumns: {
          xs: "1fr",
          sm: "repeat(2, 1fr)",
          md: "repeat(3, 1fr)",
          lg: "repeat(4, 1fr)",
        },
        gap: 3,
        mb: 4,
      }}
    >
      {documentTypes.map((documentType) => (
        <GridViewCard
          key={documentType.key}
          title={documentType.value}
          updateDate="2024-02-20"
          TitleIcon={FolderIcon}
          onClick={() => onFolderClick(documentType)}
        />
      ))}
    </Box>
  );
};

export default DocumentTypesList;
